import React, { useState } from 'react'
import styles from './MicrositeCopyableUrl.module.css'
import { Copy, Check, ExternalLink } from 'lucide-react'

/**
 * MicrositeCopyableUrl
 * URL display with one-click copy-to-clipboard, used for the
 * sitemap URL on MicrositeSitemap and domain URLs elsewhere.
 *
 * Usage:
 *   <MicrositeCopyableUrl url={sitemapConfig.sitemapUrl} />
 */
const MicrositeCopyableUrl = ({ url, openInNewTab = true }) => {
    const [copied, setCopied] = useState(false)

    if (!url) return <span className={styles.empty}>Not generated yet</span>

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(url)
            setCopied(true)
            setTimeout(() => setCopied(false), 1800)
        } catch {
            // clipboard unavailable — silently ignore
        }
    }

    return (
        <div className={styles.wrap}>
            <code className={styles.url}>{url}</code>
            <button type="button" className={styles.copyBtn} onClick={handleCopy} title="Copy URL">
                {copied ? <Check size={13} /> : <Copy size={13} />}
            </button>
            {openInNewTab && (
                <a href={url} target="_blank" rel="noopener noreferrer" className={styles.openBtn} title="Open">
                    <ExternalLink size={13} />
                </a>
            )}
        </div>
    )
}

export default MicrositeCopyableUrl